import React from 'react';
import { FormControl, TextField } from '@mui/material';
import { Unset } from '@utils';

export const FeatureUserExplanationEditor = (props: {
  userExplanation: string | Unset;
  onUserExplanationChange: (ue: string) => void;
}) => {
  return (
    <FormControl style={{ width: '100%' }}>
      <TextField
        hiddenLabel
        margin="dense"
        placeholder="User explanation"
        style={{ width: '100%', marginTop: 0 }}
        value={props.userExplanation}
        variant="standard"
        size="small"
        onChange={e => props.onUserExplanationChange(e.target.value)}
      />
    </FormControl>
  );
};
